/**
 * Arabic for the 3D section's tools — choosing a section, laying a drawing or
 * site photograph on the grid, and checking the drawing against the site.
 * Proposed; pending native aviation review.
 */
const ar: Record<string, string> = {
  Section: "القطاع",
  "{id} · {n} assets": "{id} · {n} أصل",
  "Move to the next section": "الانتقال إلى القطاع المجاور",
  OBLIQUE: "مائل",
  "FROM ABOVE": "من الأعلى",
  "Pick a section on the Interactive Map": "اختر قطاعاً من الخريطة التفاعلية",
  Ground: "الأرضية",
  "Survey drawing": "مخطط المسح",
  "Laid over it": "فوقها",
  Nothing: "لا شيء",
  "See-through": "الشفافية",
  "Add a drawing or site photo": "أضف مخططاً أو صورة للموقع",
  "None of the uploads reaches this section.": "لا يصل أي من الملفات المرفوعة إلى هذا القطاع.",
  "{m} m per pixel, turned {deg}°": "{m} م لكل بكسل، مُدار {deg}°",
  "Uploads are kept in this browser, lined up with the survey grid by two matching points. To share a drawing with the rest of the airport, put it in the document library.":
    "تُحفظ الملفات المرفوعة في هذا المتصفح، مُطابقة مع شبكة المسح بنقطتين متقابلتين. لمشاركة مخطط مع بقية المطار، ضعه في مكتبة الوثائق.",
  "Only an image can be laid on the grid here — PNG, JPG or WebP. Export a PDF or CAD sheet as an image first.":
    "يمكن وضع صورة فقط على الشبكة هنا — PNG أو JPG أو WebP. صدّر ملف PDF أو لوحة CAD كصورة أولاً.",
  "this browser": "هذا المتصفح",
  "Line it up by two points far apart: click a point on the upload, then the same point on the survey drawing — a runway threshold, a taxiway junction, a building corner. Or type the point's easting and northing if you know them.":
    "طابقه بنقطتين متباعدتين: انقر نقطة على الملف المرفوع، ثم النقطة نفسها على مخطط المسح — عتبة مدرج، أو تقاطع ممر، أو زاوية مبنى. أو اكتب الإحداثي الشرقي والشمالي للنقطة إن كنت تعرفهما.",
  Point: "النقطة",
  "POINT {n}": "النقطة {n}",
  "The upload": "الملف المرفوع",
  "The survey drawing": "مخطط المسح",
  "Point {n}": "النقطة {n}",
  "{m} m per pixel, turned {deg}° from grid north.": "{m} م لكل بكسل، مُدار {deg}° عن شمال الشبكة.",
  "Save and lay it on the grid": "احفظ وضعه على الشبكة",
  "Does the drawing match the site?": "هل يطابق المخطط الموقع؟",
  "Every asset the platform places in section {cell}, with where the platform got it from. Walk the section, and record each as where the drawing shows it, moved, or not on site — and anything on site the drawing does not show. Every check is kept.":
    "كل أصل تضعه المنصة في القطاع {cell}، مع مصدره. امشِ في القطاع وسجّل كل أصل: في مكانه كما في المخطط، أو منقول، أو غير موجود في الموقع — وكل ما في الموقع ولا يظهر في المخطط. يُحفظ كل فحص.",
  "{n} match": "{n} مطابق",
  "{n} moved": "{n} منقول",
  "{n} not on site": "{n} غير موجود في الموقع",
  "{n} not on the drawing": "{n} غير موجود في المخطط",
  "{n} not checked": "{n} لم يُفحص",
  "Nothing to show in this section.": "لا شيء لعرضه في هذا القطاع.",
  "What was seen — where it is now, or what is there instead": "ما شوهد — أين هو الآن، أو ما الموجود مكانه",
  "What was seen": "ما شوهد",
  Check: "افحص",
  "e.g. drain cover, light base, sign": "مثال: غطاء تصريف، قاعدة إنارة، لوحة",
  "e.g. north shoulder, 40 m from B3": "مثال: الكتف الشمالي، 40 م من B3",
  "{n} uploaded|{n} uploaded":
    "لا ملفات مرفوعة|ملف واحد مرفوع|ملفان مرفوعان|{n} ملفات مرفوعة|{n} ملفاً مرفوعاً|{n} ملف مرفوع",
  "{n} check|{n} checks": "لا فحوص|فحص واحد|فحصان|{n} فحوص|{n} فحصاً|{n} فحص",
  Easting: "الإحداثي الشرقي",
  Northing: "الإحداثي الشمالي",
  "On site, not on the drawing": "في الموقع، وليس في المخطط",
  Where: "أين",
  "Where the drawing shows it": "في مكانه كما في المخطط",
  Moved: "منقول",
  "Not on site": "غير موجود في الموقع",
  "Plan or drawing": "مخطط أو رسم",
  "Site photograph — drone or satellite": "صورة للموقع — طائرة مسيّرة أو قمر صناعي",
  "From the survey drawing": "من مخطط المسح",
  "From survey geometry": "من هندسة المسح",
  "From the facility register": "من سجل المرافق",
  "Derived — verify on site": "مشتق — تحقّق في الموقع",
  "Set both matching points.": "حدّد النقطتين المتقابلتين.",
  "The two points must be apart, on the upload and on the site.":
    "يجب أن تتباعد النقطتان، على الملف المرفوع وفي الموقع.",
  "The two points are too close together to fix the scale; pick them far apart.":
    "النقطتان متقاربتان جداً لتحديد المقياس؛ اخترهما متباعدتين.",
  "Name what was found.": "اذكر ما وُجد",
  "Say what was seen — where it is now, or what is there instead.": "اذكر ما شوهد — أين هو الآن، أو ما الموجود مكانه",
  ALL: "الكل",
  "NOT CHECKED": "لم يُفحص",
  "DERIVED — VERIFY": "مشتق — تحقّق",
  North: "شمال",
  South: "جنوب",
  East: "شرق",
  West: "غرب",
};
export default ar;
